import { type DetailedHTMLProps, type HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { classes } from './utils';

export type TextProps = DetailedHTMLProps<
  HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
>;

export default function Text({ className, ...props }: TextProps) {
  return <p className={twMerge(classes.text, className)} {...props} />;
}
